import React from "react";
import Table from "./FormElements/Table";
import Flags from "./FormElements/Flags";
import Tooltips from "./FormElements/Tooltips";
import { handleState, transformDate } from "../Utils/utils";

const TableRequestRVO = ({ data }) => {
  return (
    <>
      <div className="table-box">
        <a
          style={{ display: "none" }}
          target="_blank"
          rel="noopener noreferrer"
        />
        <Table>
          <thead>
            <tr>
              <th width="96px">N° OPERACIÓN</th>
              <th>CUSPP</th>
              <th>DNI</th>
              <th width="120px">FEC. SOLICITUDES</th>
              <th width="120px">FEC. CIERRE</th>
              <th width="180px">ESTADO</th>
              <th>REM. PROMEDIO</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((item, index) => (
                <tr key={index}>
                  <td>{item.nroOperacion}</td>
                  <td>{item.CUSPP}</td>
                  <td>{item.afiliado.nroDoc}</td>
                  <td>{transformDate(item.fechaCargaXML)}</td>
                  <td>{transformDate(item.fechaCierre)}</td>
                  <td>
                    <div className="flag-state-info">
                      <Flags variant={item.estado} widthreprom={item.necesitaRemuneracionPromedio}>
                        {handleState(item.estado, item.necesitaRemuneracionPromedio)}
                      </Flags>
                      {item.descripcionEstado && (
                        <Tooltips text={item.descripcionEstado} />
                      )}
                    </div>
                  </td>
                  <td>
                    {item.remuneracionPromedio
                      ? item.remuneracionPromedio
                      : "-"}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default TableRequestRVO;
